export default class UnloadUsersAdmin {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.gateways.agentProfile.unsubscribeAll();
    this.context.gateways.user.unsubscribe();
    this.context.stores.users.set([]);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/users/unload_users_admin.js